import { forwardRef } from 'react';
import type { DropdownProps } from '@hotjar/hotsauce';
import { NavDropdown } from './NavDropdown';
import { NavList } from './NavList';

export const NavDropdownMenu = forwardRef<HTMLElement, DropdownProps>(
  ({ children, ...props }: DropdownProps, ref): JSX.Element => (
    <NavDropdown {...props} ref={ref}>
      <NavList role="menu">{children}</NavList>
    </NavDropdown>
  ),
);

NavDropdownMenu.displayName = 'NavDropdownMenu';
